import React from "react";
import { Dimensions, StyleSheet, TouchableOpacity, View, Modal } from "react-native";
import { ColorTokens, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, TextAlignTokens } from "@voltmoney/schema";
import { Typography } from "../../typography/Typography";
import { Space } from "../../space/Space";
import { isMobile } from "../../stack/utils";
import { getScreenType } from "../utils";
const Logout = ({ triggerAction, yesAction, noAction }) => {
    return (React.createElement(Modal, { animationType: 'fade', transparent: true, onRequestClose: () => {
        } },
        React.createElement(View, { style: {
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                backgroundColor: '#1D293966',
            } },
            React.createElement(View, { style: {
                    backgroundColor: 'white',
                    width: '70%',
                    maxWidth: 508,
                    height: '20%',
                    borderRadius: 10,
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderColor: 'black',
                    borderWidth: 2,
                    padding: 10,
                } },
                React.createElement(Typography, { label: "Are you sure you want to logout?", color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Poppins, fontWeight: "400", lineHeight: 24, textAlign: TextAlignTokens.center }),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        justifyContent: 'space-evenly',
                        width: '100%',
                        height: 35,
                        alignItems: 'center',
                    } },
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            justifyContent: 'space-evenly',
                            width: '100%',
                        } },
                        React.createElement(View, { style: {
                                width: 40,
                                height: 35,
                                alignItems: 'center',
                                justifyContent: 'center',
                            } },
                            React.createElement(TouchableOpacity, { onPress: () => {
                                    triggerAction({
                                        ...yesAction
                                    });
                                } },
                                React.createElement(Typography, { label: "Yes", color: ColorTokens.Primary_100, fontSize: FontSizeTokens.SM, fontWeight: "400", lineHeight: 18 }))),
                        React.createElement(View, { style: {
                                width: 40,
                                height: 35,
                                alignItems: 'center',
                                justifyContent: 'center',
                            } },
                            React.createElement(TouchableOpacity, { onPress: () => triggerAction({
                                    ...noAction
                                }) },
                                React.createElement(Typography, { label: "No", color: ColorTokens.Primary_100, fontSize: FontSizeTokens.SM, fontWeight: "400", lineHeight: 18 })))))))));
};
const styles = StyleSheet.create({
    container: {
        height: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height - 70 : Dimensions.get('window').height - 114,
    },
    blankContainer: {
        height: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height - 70 : Dimensions.get('window').height - 114,
    },
    backdrop: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    backdropText: {
        color: 'white',
        fontSize: 16,
    },
    contentContainer: {
        paddingHorizontal: 16,
        flex: 1
    },
    card: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        height: '50%',
        padding: 20,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
    },
    cardText: {
        fontSize: 18,
    },
    boldText: {
        fontWeight: 'bold',
        color: '#1D2939',
        fontSize: 14
    },
});
export default (Logout);
